import { connect } from 'react-redux';
import { getGiftCardBarber } from '../selectors';

export default connect(
  state => ({
    gcBarber: getGiftCardBarber(state),
  }),
);



// WEBPACK FOOTER //
// ./src/app/giftCard/hoc/withGiftCardBarber.js